import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import FeatureCategoryContainer from '../../containers/feature-category-container';
import Promo from '../../containers/promo';
import Video from '../../blocks/video';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const FeatureCategoryContainerBlock = props => <FeatureCategoryContainer {...props} />;
FeatureCategoryContainerBlock.displayName = 'FeatureCategoryContainer';

export default withDynamicComponents({
  componentWhitelist: [
    FeatureCategoryContainer,
    Promo,
    Video,
    Html,
    Wysiwyg,
  ],
  mapInputToOutput: [
    ['components', 'components'],
  
  ],
})(FeatureCategoryContainerBlock);



// WEBPACK FOOTER //
// ./src/blocks/feature-category-container/index.jsx